export default "__VITE_ASSET__CWD4r7p8__"